import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/mainPage/home'
  },
  {
    path: '/login',
    name: 'Login',
    meta: { title: 'login' },
    component: () => import('@/views/jtwallet/login.vue')
  },
  {
    path: '/activate/:mobile',
    name: 'Activate',
    meta: { title: 'activate_auto_debit' },
    component: () => import('@/views/jtwallet/activate-auto-debit.vue')
  },
  {
    path: '/bluepay',
    name: 'BluePay',
    meta: { title: '' },
    component: () => import('@/views/jtwallet/login-after-wait.vue')
  },
  // {
  //   path: '/register',
  //   name: 'Register',
  //   meta: { title: 'register' },
  //   component: () => import('@/views/jtwallet/register.vue')
  // },
  {
    path: '/resetPassword',
    name: 'ResetPassword',
    meta: { title: 'reset_password' },
    component: () => import('@/views/jtwallet/reset-password.vue')
  },
  {
    path: '/withholding',
    name: 'Withholding',
    meta: { title: 'withholding' },
    component: () => import('@/views/jtwallet/withholding/activate-auto-debit.vue')
  },
  {
    path: '/protocol',
    name: 'Protocol',
    meta: { title: 'protocol' },
    component: () => import('@/views/jtwallet/withholding/protocol/protocol.vue')
  },
  {
    path: '/protocolTh',
    name: 'ProtocolTh',
    meta: { title: 'protocol' },
    component: () => import('@/views/jtwallet/withholding/protocol/protocol-th.vue')
  },
  {
    path: '/newProtocol',
    name: 'newProtocol',
    meta: { title: 'protocol' },
    component: () => import('@/views/jtwallet/withholding/protocol/new-protocol.vue')
  },
  {
    path: '/activationSuccessful',
    name: 'ActivationSuccessful',
    meta: { title: 'activationSuccessful' },
    component: () => import('@/views/jtwallet/withholding/activation-successful.vue')
  },
  {
    path: '/autoDebit',
    name: 'AutoDebit',
    meta: { title: 'autoDebit' },
    component: () => import('@/views/jtwallet/withholding/auto-debit.vue')
  },
  {
    path: '/merchantInformation',
    name: 'merchantInformation',
    meta: { title: 'merchantInformation' },
    component: () => import('@/views/jtwallet/withholding/merchant-information.vue')
  },
  {
    path: '/terminationCompleted',
    name: 'terminationCompleted',
    meta: { title: 'terminationCompleted' },
    component: () => import('@/views/jtwallet/withholding/termination-completed.vue')
  },
  {
    path: '/helpCenter',
    name: 'HelpCenter',
    meta: { title: 'help_center' },
    component: () => import('@/views/jtwallet/settings/help-center.vue')
  },
  {
    path: '/privacy',
    name: 'Privacy',
    meta: { title: 'privacy' },
    component: () => import('@/views/jtwallet/settings/privacy.vue')
  },
  {
    path: '/language',
    name: 'Language',
    meta: { title: 'language' },
    component: () => import('@/views/jtwallet/settings/language.vue')
  },
  {
    path: '/kycPrivacy',
    name: 'kycPrivacy',
    meta: { title: 'privacy' },
    component: () => import('@/common/kyc-privacy.vue')
  },
  {
    path: '/faq',
    name: 'Faq',
    meta: { title: 'faq' },
    component: () => import('@/views/jtwallet/settings/faq.vue')
  },
  {
    path: '/feedback',
    name: 'Feedback',
    meta: { title: 'feedback' },
    component: () => import('@/views/jtwallet/settings/feedback.vue')
  },
  {
    path: '/feedBackHistory',
    name: 'FeedBackHistory',
    meta: { title: 'feedback_history' },
    component: () => import('@/views/jtwallet/settings/feedback-history.vue')
  },
  {
    path: '/feedBackResult',
    name: 'FeedBackResult',
    meta: { title: 'feedback_history' },
    component: () => import('@/views/jtwallet/settings/feedback-result.vue')
  },
  {
    path: '/404',
    meta: { title: 'page_not_found' },
    component: () => import('@/views/jtwallet/404.vue')
  },
  {
    name: 'JTBillDetail', //  path: 'auditManage/reCheck/detail/:merchant_no/:final_audit_status',
    path: '/jtBillDetail/:bill_number',
    meta: { title: 'bill_detail' },
    component: () => import('@/views/jtwallet/account/jt-bills/jt-bill-details.vue'),
    hidden: true
  },
  {
    name: 'BillPaymentHistory',
    path: '/billPaymentHistory/:bill_number',
    meta: { title: 'bill_payment_history' },
    component: () => import('@/views/jtwallet/account/jt-bills/jt-bill-payment-history.vue'),
    hidden: true
  },
  {
    name: 'BillPaymentDetails',
    path: '/billPaymentDetails',
    meta: { title: 'bill_payment_detail' },
    component: () => import('@/views/jtwallet/account/jt-bills/jt-bill-payment-details.vue'),
    hidden: true
  },
  {
    name: 'TransactionDetail',
    path: '/transactionDetail',
    meta: { title: 'historyDetail' },
    component: () => import('@/views/jtwallet/order/history-detail.vue'),
    hidden: true
  },
  {
    name: 'QRTransactionDetail',
    path: '/qrTransactionDetail',
    meta: { title: 'historyDetail' },
    component: () => import('@/views/jtwallet/order/history-QR-detail.vue'),
    hidden: true
  },
  {
    path: '/SplashPage',
    component: () => import('@/views/jtwallet/splash-page.vue')
  },
  {
    name: 'TopUpStatus',
    path: '/topUp/status/:id',
    meta: { title: 'top_up' },
    component: () => import('@/views/jtwallet/account/top-up/check-top-up-status.vue')
  },
  {
    name: 'CashOutStatus',
    path: '/cashOut/status/:id',
    meta: { title: 'cash_out' },
    component: () => import('@/views/jtwallet/account/cash-out/check-cash-out-status.vue')
  },
  {
    name: 'TransferOutStatus',
    path: '/transfer/status/:id',
    meta: { title: 'transfer' },
    component: () => import('@/views/jtwallet/account/transfer/check-transfer-out-status.vue')
  },
  {
    name: 'TopUpMobileStatus',
    path: '/topUpMobile/status/:id',
    meta: { title: 'mobile_top_up' },
    component: () => import('@/views/jtwallet/account/top-up/check-top-up-mobile-status.vue')
  },
  {
    name: 'BankAccountsList',
    path: '/bankAccounts',
    component: () => import('@/views/jtwallet/account/bank-accounts-list.vue'),
    meta: {
      title: 'Bank Accounts'
    }
  },
  {
    name: 'PromotionList',
    path: '/promotion',
    component: () => import('@/views/jtwallet/account/promotion-list.vue'),
    meta: {
      title: 'PromotionList'
    }
  },
  {
    name: 'AddBankAccount',
    path: '/addBankAccount',
    component: () => import('@/views/jtwallet/account/add-bank-account.vue'),
    meta: {
      title: 'new_account'
    }
  },
  {
    name: 'IdentityChoose',
    path: '/identityChoose',
    component: () => import('@/views/jtwallet/account/identity/identity-choose.vue'),
    meta: {
      title: 'identity'
    }
  },
  {
    name: 'IdentityEnterprise',
    path: '/identityEnterprise',
    component: () => import('@/views/jtwallet/account/identity/identity-enterprise.vue'),
    meta: {
      title: 'identity'
    }
  },
  {
    name: 'Identity',
    path: '/identity',
    component: () => import('@/views/jtwallet/account/identity/identity-information.vue'),
    meta: {
      title: 'identity'
    }
  },

  {
    name: 'DopaAuthentication',
    path: '/dopaAuthentication',
    component: () => import('@/views/jtwallet/account/dopa-enhanced-kyc/dopa-authentication.vue'),
    meta: {
      title: 'dopaAuthentication'
    }
  },
  {
    name: 'DopaAuthenticationManual',
    path: '/dopaAuthenticationManual',
    component: () => import('@/views/jtwallet/account/dopa-enhanced-kyc/dopa-authentication-manual.vue'),
    meta: {
      title: 'dopaAuthenticationManual'
    }
  },
  {
    name: 'DopaAuthenticationStatus',
    path: '/dopaAuthenticationStatus',
    component: () => import('@/views/jtwallet/account/dopa-enhanced-kyc/dopa-authentication-status.vue'),
    meta: {
      title: 'dopaAuthenticationStatus'
    }
  },
  {
    name: 'RegisterAuth',
    path: '/registerAuth',
    component: () => import('@/views/jtwallet/account/zoloz-enhanced-kyc/register-auth.vue'),
    meta: {
      title: 'RegisterAuth'
    }
  },
  {
    name: 'RegisterInfoConfirm',
    path: '/registerInfoConfirm',
    component: () => import('@/views/jtwallet/account/zoloz-enhanced-kyc/register-info-confirm.vue'),
    meta: {
      title: 'RegisterInfoConfirm'
    }
  },
  {
    name: 'RegisterInfoDetail',
    path: '/registerInfoDetail',
    component: () => import('@/views/jtwallet/account/zoloz-enhanced-kyc/register-info-detail.vue'),
    meta: {
      title: 'RegisterInfoDetail'
    }
  },
  {
    name: 'CertificationForZolozEnhance',
    path: '/certificationForZolozEnhance',
    component: () => import('@/common/certification-for-zoloz-enhance.vue'),
    meta: {
      title: 'service_certification'
    }
  },
  {
    name: 'ServiceCertification',
    path: '/serviceCertification',
    component: () => import('@/common/service-certification.vue'),
    meta: {
      title: 'service_certification'
    }
  },

  {
    path: '/checkPin',
    name: 'CheckPin',
    meta: { title: 'pin' },
    component: () => import('@/views/jtwallet/pin/check-pin.vue')
  },
  {
    path: '/pinWithOtp',
    name: 'PinWithOtp',
    meta: { title: 'pin' },
    component: () => import('@/views/jtwallet/pin/pin-with-otp.vue')
  },
  {
    path: '/pinWithFace',
    name: 'PinWithFace',
    meta: { title: 'pin' },
    component: () => import('@/views/jtwallet/pin/pin-with-face.vue')
  },
  {
    path: '/unlockPinWithFace',
    name: 'UnlockPinWithFace',
    meta: { title: 'pin' },
    component: () => import('@/views/jtwallet/pin/unlock-pin-with-face.vue')
  },
  {
    path: '/pinToAddFace',
    name: 'PinToAddFace',
    meta: { title: 'pin' },
    component: () => import('@/views/jtwallet/pin/pin-to-add-face.vue')
  },
  {
    path: '/pinWithOldPin',
    name: 'PinWithOldPin',
    meta: { title: 'pin' },
    component: () => import('@/views/jtwallet/pin/pin-with-old-pin.vue')
  },
  {
    path: '/pinWithFaceFail',
    name: 'PinWithFaceFail',
    meta: { title: 'pin' },
    component: () => import('@/views/jtwallet/pin/pin-with-face-fail.vue')
  },
  {
    path: '/pinSetUp',
    name: 'PinSetUp',
    meta: { title: 'pin' },
    component: () => import('@/views/jtwallet/pin/pin-set-up.vue')
  },
  {
    path: '/pinComplete',
    name: 'PinComplete',
    meta: { title: 'pin' },
    component: () => import('@/views/jtwallet/pin/pin-complete.vue')
  },

  {
    path: '/accountLimits',
    name: 'AccountLimits',
    meta: { title: 'account_limits' },
    component: () => import('@/views/jtwallet/settings/account-limits.vue')
  },

  {
    path: '/verificationLevels',
    name: 'VerificationLevels',
    meta: { title: 'verification_levels' },
    component: () => import('@/views/jtwallet/settings/verification-levels.vue')
  },
  {
    name: 'IdentityView',
    path: '/identity-view',
    component: () => import('@/views/jtwallet/account/identity/identity-information-view.vue'),
    meta: {
      title: 'identity-information-view'
    }
  },
  {
    name: 'PersonalInformation',
    path: '/personalInformation',
    meta: { title: 'personal_information' },
    component: () => import('@/views/jtwallet/account/personal-information.vue'),
    hidden: true
  },
  {
    name: 'ServicePolicy',
    path: '/servicePolicy',
    component: () => import('@/views/jtwallet/settings/service-policy.vue'),
    meta: {
      title: 'service_policy'
    }
  },
  {
    name: 'PrivacyAgreement',
    path: '/privacyAgreement',
    component: () => import('@/views/jtwallet/settings/privacy-agreement.vue'),
    meta: {
      title: 'privacy_agreement'
    }
  },

  {
    name: 'MainPage',
    path: '/mainPage',
    redirect: '/mainPage/home',
    component: () => import('@/views/jtwallet/main-page.vue'),
    meta: { keepAlive: true },
    hidden: true,
    children: [
      {
        name: 'home',
        path: 'home',
        component: () => import('@/views/jtwallet/tabbar/home.vue'),
        meta: {
          keepAlive: true,
          keepScroll: true,
          scrollTop: 0,
          scrollContainer: '.main-router-view',
          title: 'home'
        }
      },
      {
        name: 'transactions',
        path: 'transactions',
        component: () => import('@/views/jtwallet/tabbar/transactions.vue'),
        meta: {
          keepAlive: true,
          keepScroll: true,
          scrollTop: 0,
          scrollContainer: '.main-router-view',
          title: 'transactions'
        }
      },
      {
        path: '/notify',
        name: 'notify',
        component: () => import('@/views/jtwallet/notify/notify.vue'),
        meta: {
          keepAlive: true,
          keepScroll: true,
          scrollTop: 0,
          scrollContainer: '.main-router-view',
          title: 'inbox'
        }
      },
      {
        name: 'settings',
        path: 'settings',
        component: () => import('@/views/jtwallet/tabbar/settings.vue'),
        meta: {
          keepAlive: true,
          title: 'profile'
        }
      }
    ]
  },
  {
    name: 'Assets',
    path: '/assets',
    component: () => import('@/views/jtwallet/account/assets.vue'),
    meta: {
      title: 'assets'
    }
  },
  {
    name: 'Transfer',
    path: '/transfer',
    meta: { title: 'Transfer' },
    component: () => import('@/views/jtwallet/account/transfer/transfer.vue')
  },
  {
    name: 'CashOut',
    path: '/cashOut',
    meta: { title: 'cash_out' },
    component: () => import('@/views/jtwallet/account/cash-out/cash-out.vue')
  },
  {
    name: 'TopUp',
    path: '/topUp',
    meta: { title: 'top_up' },
    component: () => import('@/views/jtwallet/account/top-up/top-up.vue')
  },
  {
    name: 'MobileTopUp',
    path: '/topUp/mobile',
    meta: { title: 'mobile_top_up' },
    component: () => import('@/views/jtwallet/account/top-up/top-up-mobile.vue')
  },
  {
    name: 'JTBills',
    path: '/jtBills',
    meta: { title: 'jt_bills' },
    component: () => import('@/views/jtwallet/account/jt-bills/jt-bills.vue')
  },
  {
    name: 'DeactivateCanNot',
    path: '/deactivateCanNot',
    meta: { title: 'deactivate_account' },
    component: () => import('@/views/jtwallet/deactivate/deactivate-can-not.vue')
  },
  {
    name: 'DeactivateSuccess',
    path: '/deactivateSuccess',
    meta: { title: 'deactivate_account' },
    component: () => import('@/views/jtwallet/deactivate/deactivate-success.vue')
  },
  {
    name: 'DeactivateVerify',
    path: '/deactivateVerify',
    meta: { title: 'deactivate_account' },
    component: () => import('@/views/jtwallet/deactivate/deactivate-verify.vue')
  }
]

const asyncRoutes = []

function integrationRoutes() {
  const integrationRoutes = []

  asyncRoutes.forEach(route => {
    route.forEach(item => {
      integrationRoutes.push(item)
    })
  })
  integrationRoutes.push({ path: '*', redirect: '/jtwallet/404', hidden: true })
  return routes.concat(integrationRoutes)
}

const router = new VueRouter({
  mode: 'hash',
  routes: integrationRoutes()
})

router.beforeEach((to, from, next) => {
  // console.log('🌐 全局监听：即将从', from.fullPath, '到', to.fullPath)
  // 定义页面白名单
  const personSavePage = new Set(['/kycPrivacy?nationType=jt'])
  const enterpriseSavePage = new Set(['/registerInfoConfirm'])

  // 配置来源路由与对应的清理规则
  const clearRules = {
    '/identity': {
      exclude: personSavePage,
      keys: ['checkBoxStatus', 'nationalType']
    },
    '/registerAuth': {
      exclude: new Set([...personSavePage, ...enterpriseSavePage]),
      keys: ['zolozRegisterIsChecked']
    }
  }

  // 清理逻辑
  function clearSessionStorage(from, to) {
    const rule = clearRules[from.fullPath]
    if (!rule) return

    // 如果目标路由不在排除列表中，清理对应 sessionStorage
    if (!rule.exclude.has(to.fullPath)) {
      rule.keys.forEach(key => sessionStorage.removeItem(key))
    }
  }

  // 调用
  clearSessionStorage(from, to)
  next()
})

router.afterEach((to, from) => {
  // console.log('🌐 路由已跳转到', to.fullPath)
})

export default router
